import { AuthProvider } from 'ra-core';

const authProvider: AuthProvider = {
    login: ({ username }) => {
        localStorage.setItem('username', username);
        // accept all username/password combinations
        return Promise.resolve();
    },
    logout: () => {
        localStorage.removeItem('username');
        return Promise.resolve();
    },
    checkError: () => Promise.resolve(),
    checkAuth: () => {
        // Allow access to reset-password and forgot-password screens without being logged in
        const hash = window.location.hash || '';
        if (hash.startsWith('#/reset-password') || hash.startsWith('#/forgot-password')) {
            return Promise.resolve();
        }
        return localStorage.getItem('username') ? Promise.resolve() : Promise.reject({ message: 'login.required' });
    },
     getPermissions: (props) => {
        let per = localStorage.getItem("menu");
        if(per){
            per = JSON.parse(per);
        }
        return per ? Promise.resolve(per) : Promise.reject();
    },
};

export default authProvider;
